import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const getNotifications = async (reqData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getNotificationsApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: reqData,
  });

  return data;
};

export const readNotifications = async (detailsData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.markReadNotificationApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: detailsData,
  });

  return data;
};

const NotificationService = { getNotifications, readNotifications };
export default NotificationService;
